import { render, staticRenderFns } from "./LandPage.vue?vue&type=template&id=3ead1660&scoped=true"
import script from "./LandPage.vue?vue&type=script&lang=js"
export * from "./LandPage.vue?vue&type=script&lang=js"
import style0 from "./LandPage.vue?vue&type=style&index=0&id=3ead1660&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ead1660",
  null
  
)

export default component.exports